var map = {
	"./0.png": 1757,
	"./1.png": 1758,
	"./2.png": 1759,
	"./3.png": 1760,
	"./4.png": 1761,
	"./5.png": 1762
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 801;


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/ranks ^\.\/.*$
// module id = 801
// module chunks = 0